module.exports = __webpack_public_path__ + "img/chofu_service_off.22fb7d06.svg";